import script from "./GridAudioFileManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GridAudioFileManager.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__